
const FormIcon = () => {
    return (
        <i className="bi-card-checklist"></i>
    )
}

export default FormIcon